import { render, staticRenderFns } from "./AddDiscountsTemplatesModal.vue?vue&type=template&id=93498d9a&"
import script from "./AddDiscountsTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./AddDiscountsTemplatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports